import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/home';
import "./css/preset.css"
import Header from './components/header';
import Footer from './components/footer';
import Docs from './components/docs';
import Guides from './components/guides';
import Reference from './components/reference';
import Download from './components/download';
import Search from './components/search';
import Admin from './components/admin';
import NotFound from './components/not-found';

var env = process.env;

function App() {
   return (
      <BrowserRouter>
         <Header />
         <Routes>
            <Route path='/' Component={Home} />
            <Route path='/docs' Component={Docs} />
            <Route path='/guides' Component={Guides} />
            <Route path='/download' Component={Download} />
            <Route path='/admin/*' Component={Admin} />
            <Route path='/manual/reference/:id' Component={Reference} />
            <Route path='/search/' Component={Search} />
            <Route path='*' Component={NotFound} />
         </Routes>
         <Footer />
      </BrowserRouter>
   );
}

export default App;
